/**
 * Copyright 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { withAuth0 } from '@auth0/auth0-react';

const breadcrumbsOverwrite = {
  api_keys: 'API keys',
};

function mapPathnameToBreadcrumbs(pathname) {
  return pathname
    .split('/')
    .filter(el => el.length > 0)
    .map(el => (breadcrumbsOverwrite[el] ? breadcrumbsOverwrite[el] : el))
    .map(el => el.replace('_', ' '));
}

class NavigationHeader extends Component {
  constructor() {
    super();
    this.state = {
      department: '',
      email: '',
      customerName: localStorage.getItem('currentCustomerName'),
    };
  }
  componentWillMount() {
    const { router } = this.props;
    const pathname = router.getCurrentLocation().pathname;
    this.setState({ department: mapPathnameToBreadcrumbs(pathname) });
  }
  componentDidMount() {
    const { router } = this.props;
    const { user } = this.props.auth0;
    this.setState({ email: user.email });

    router.listen(({ pathname }) =>
      this.setState({ department: mapPathnameToBreadcrumbs(pathname) }),
    );
  }

  render() {
    const { logout } = this.props.auth0;
    const { department, email } = this.state;

    return (
      <header className="page-header">
        <div
          className="page-header-logo"
          onClick={e => {
            e.stopPropagation();
            browserHistory.push(`/dashboard`);
          }}
        >
          <svg width="30px" height="22px" viewBox="0 0 30 22" version="1.1">
            <g id="Dashboard-View" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
              <g
                id="Spends---menu"
                transform="translate(-21.000000, -17.000000)"
                fill="#161632"
                fillRule="nonzero"
              >
                <path
                  d="M50.9615938,30.3160596 C50.9615938,30.2642947 50.9532446,30.21086 50.9465653,30.1590952 C50.9248575,29.9537055 50.8948004,29.7516556 50.8547244,29.5529453 C50.8447054,29.5028503 50.8313467,29.4527552 50.8196579,29.4009904 C50.7845914,29.2456958 50.7445153,29.092071 50.7010997,28.9417859 C50.6827315,28.8766624 50.6643633,28.8132087 50.6443253,28.749755 C50.5875509,28.5727525 50.5240972,28.4007596 50.4539642,28.2304365 C50.425577,28.1603035 50.3938501,28.0935101 50.3637931,28.0250469 C50.3070187,27.8964696 50.2469047,27.7712321 50.1817812,27.6476643 C50.1517242,27.5908899 50.1250068,27.5307759 50.09328,27.4806809 C50.0047787,27.3136974 49.9079283,27.1650822 49.8077383,27.0131273 C49.7693321,26.9530132 49.7275862,26.8928992 49.6875102,26.834455 C49.58899,26.6941889 49.4871301,26.5572625 49.3802607,26.4236757 L49.2917595,26.3184762 C49.1765409,26.1798799 49.054643,26.047963 48.9294054,25.9193858 C48.8926691,25.8793097 48.8542629,25.8409036 48.8141869,25.8024974 C48.6705811,25.6622313 48.5236357,25.5253049 48.3683411,25.3967276 C48.1629515,25.231414 48.0109965,25.1195351 47.8557019,25.0160054 L47.7555119,24.9475422 C47.7271247,24.929174 47.7020772,24.9074662 47.67369,24.889098 C47.4668139,21.5429482 45.2917821,18.639512 42.1386804,17.5004485 C38.9855786,16.3613851 35.457125,17.2044273 33.1594899,19.6458182 C32.7775973,19.5822905 32.391105,19.5504551 32.0039646,19.5506376 C28.6728928,19.5586545 25.7923642,21.8745912 25.0691426,25.1262145 C22.5102894,26.261844 20.9006487,28.8409723 21.0047658,31.6385684 C21.1400224,35.3439308 24.3010188,38.2260649 28.01807,38.2260649 L35.9163864,38.2260649 C35.915502,37.4460381 35.6045601,36.6983598 35.0520587,36.1477376 C34.4995573,35.5971155 33.7508239,35.2887228 32.9707986,35.2904961 L27.9713146,35.2904961 C25.8222378,35.2904961 23.9754011,33.6022936 23.9403345,31.4498771 C23.9215188,30.4030874 24.3241124,29.3926396 25.057642,28.6456075 C25.7911716,27.8985754 26.7941088,27.4776201 27.8410676,27.4773412 C27.5897992,25.8299054 28.2783604,24.142751 29.6702321,23.199988 C31.0621038,22.2572249 32.8843071,22.2437513 34.2899678,23.1658289 C35.446713,20.5724257 38.3959427,19.2958663 41.0784659,20.2274611 C43.7609892,21.159056 45.2841669,23.9888067 44.5844965,26.7409443 C44.6613088,26.7559728 44.7347816,26.7776806 44.8099241,26.7960488 L44.9769075,26.8377947 C45.0470406,26.8595025 45.1171736,26.88455 45.1873067,26.9095975 C45.2574397,26.9346451 45.2975157,26.9480037 45.3542901,26.9697116 C45.4110645,26.9914194 45.4878768,27.0264859 45.5530004,27.056543 L45.7199838,27.1333553 C45.7817677,27.1650822 45.8435516,27.2001487 45.9053354,27.2352152 L46.06063,27.328726 C46.1190742,27.3654623 46.1758486,27.4038685 46.2276135,27.4422747 C46.2793783,27.4806809 46.3294734,27.5174172 46.3778985,27.5558234 C46.4263237,27.5942296 46.4847679,27.6359755 46.534863,27.6793912 C46.584958,27.7228069 46.6367229,27.7695622 46.6868179,27.8163176 C46.7369129,27.8630729 46.776989,27.8981395 46.8204046,27.9415552 C46.907236,28.030613 46.9907278,28.1224539 47.0708798,28.2170778 C47.1009368,28.2521443 47.1259843,28.2905505 47.1543715,28.3272869 C47.2061364,28.3940803 47.2595711,28.4608736 47.3079963,28.5310067 C47.3564215,28.6011397 47.3647706,28.6228476 47.3948277,28.6679331 C47.4248847,28.7130186 47.4766495,28.7981802 47.5150557,28.8666434 C47.5534619,28.9351066 47.5668206,28.9651636 47.5935379,29.0152586 C47.6202553,29.0653537 47.6620012,29.1521851 47.6920582,29.2223181 C47.7221152,29.2924511 47.7371437,29.3258478 47.7571817,29.3776127 C47.7772197,29.4293776 47.8122862,29.5228883 47.8373338,29.596361 C47.8623813,29.6698337 47.8724003,29.7032304 47.8890986,29.7633444 C47.905797,29.8234585 47.9308445,29.9203088 47.9492127,30.0004609 C47.9609015,30.0522258 47.9742602,30.1023208 47.9842792,30.1557555 C48.0026474,30.2442567 48.0143362,30.3344278 48.026025,30.4262687 C48.026025,30.4713542 48.0393837,30.5147699 48.0443932,30.5615252 C48.0577519,30.6984517 48.0644312,30.8370479 48.0644312,30.977314 C48.0655187,31.4121592 48.000199,31.8446209 47.8707304,32.2597468 C47.8080055,32.4578989 47.7304162,32.6510348 47.6386235,32.8375094 C47.482934,33.1638987 47.2871674,33.4696087 47.0558513,33.7475692 C46.8859999,33.9494276 46.6988222,34.1360467 46.4964568,34.3052938 C46.3895874,34.3921252 46.2793783,34.4722773 46.1624899,34.5524293 C45.9319556,34.7089409 45.6863881,34.8420731 45.4294326,34.9498499 C45.300165,35.0052078 45.1680641,35.0537005 45.0336819,35.0951255 C44.76147,35.1778107 44.4818393,35.2337369 44.1987647,35.2621089 C42.9853961,35.3842022 41.7769479,34.987753 40.8717068,34.1706186 C39.9664656,33.3534842 39.448774,32.1917981 39.4464162,30.9723045 L41.2064216,30.9723045 C41.2640352,30.928436 41.2643292,30.9075871 41.2548468,30.8904826 L38.249145,25.6805995 C38.1931737,25.584711 38.0904955,25.525755 37.9794667,25.525755 C37.868438,25.525755 37.7657598,25.584711 37.7097885,25.6805995 L34.7040867,30.8904826 C34.7127298,30.9625166 34.7311378,30.972857 34.750842,30.9723045 L36.4991586,30.9723045 C36.4991586,34.9766013 39.7452825,38.2227252 43.7495793,38.2227252 C47.7538761,38.2227252 51,34.9766013 51,30.9723045 C50.9949905,30.7502165 50.9816318,30.5314682 50.9615938,30.3160596 Z"
                  id="Shape"
                />
              </g>
            </g>
          </svg>
        </div>
        <div className="page-header-title">
          <span>Auto Patcher</span>
          <h3>
            {department.map((el, index, arr) =>
              el !== 'details' ? (
                <React.Fragment key={el}>
                  {el} {index < arr.length - 1 && '/'}{' '}
                </React.Fragment>
              ) : null,
            )}
          </h3>
        </div>

        <div className="page-header-user">
          <div className="dropdown is-hoverable is-right">
            <div className="dropdown-trigger ">
              <strong>{this.state.customerName}</strong>{' '}
              <span className="icon is-small">
                <i className="fa fa-angle-down" aria-hidden="true" />
              </span>
            </div>
            <div className="dropdown-menu" id="dropdown-menu" role="menu">
              <div className="dropdown-content">
                <a
                  className="dropdown-item"
                  onClick={e => {
                    e.preventDefault();
                    this.props.resetCustomer();
                  }}
                  title="Switch customer"
                  href="#reset"
                >
                  <i className="fa fa-building" /> <strong> </strong>Switch customer
                </a>

                <a
                  href="#logout"
                  className="dropdown-item"
                  onClick={e => {
                    e.preventDefault();
                    logout({
                      returnTo: window.location.origin,
                    });
                  }}
                >
                  <i className="fa fa-user" /> Logout <strong>{email}</strong>
                </a>
              </div>
            </div>
          </div>
        </div>
      </header>
    );
  }
}

export default withAuth0(NavigationHeader);
